import { apiFetch, apiFetchJson } from "./apiClient";
import type {
  PendingInvitation,
  InviteUsersResult,
  InviteLink,
  InviteLinkPreview,
} from "../types/invite";

const BASE = "/api/protected";

export class InviteService {
  // ---- DM: invite by username + manage pending ----
  static inviteUsers(campaignId: number, usernames: string[]): Promise<InviteUsersResult> {
    return apiFetchJson<InviteUsersResult>(`${BASE}/campaigns/${campaignId}/invites`, {
      method: "POST",
      body: JSON.stringify({ usernames }),
    });
  }

  static listCampaignInvites(campaignId: number): Promise<PendingInvitation[]> {
    return apiFetchJson<PendingInvitation[]>(`${BASE}/campaigns/${campaignId}/invites`);
  }

  static async revokeInvite(campaignId: number, inviteId: number): Promise<void> {
    const res = await apiFetch(`${BASE}/campaigns/${campaignId}/invites/${inviteId}`, {
      method: "DELETE",
    });
    if (!res.ok) throw new Error("Failed to revoke invite");
  }

  // ---- DM: shareable link ----
  static async getInviteLink(campaignId: number): Promise<InviteLink | null> {
    try {
      return await apiFetchJson<InviteLink>(`${BASE}/campaigns/${campaignId}/invite-link`);
    } catch {
      return null; // 404 = no active link
    }
  }

  static createInviteLink(campaignId: number): Promise<InviteLink> {
    return apiFetchJson<InviteLink>(`${BASE}/campaigns/${campaignId}/invite-link`, {
      method: "POST",
    });
  }

  static async revokeInviteLink(campaignId: number): Promise<void> {
    const res = await apiFetch(`${BASE}/campaigns/${campaignId}/invite-link`, { method: "DELETE" });
    if (!res.ok) throw new Error("Failed to revoke link");
  }

  // ---- Invitee inbox ----
  static listMyInvitations(): Promise<PendingInvitation[]> {
    return apiFetchJson<PendingInvitation[]>(`${BASE}/invitations`);
  }

  static acceptInvitation(inviteId: number): Promise<{ campaignId: number }> {
    return apiFetchJson<{ campaignId: number }>(`${BASE}/invitations/${inviteId}/accept`, {
      method: "POST",
    });
  }

  static async rejectInvitation(inviteId: number): Promise<void> {
    const res = await apiFetch(`${BASE}/invitations/${inviteId}/reject`, { method: "POST" });
    if (!res.ok) throw new Error("Failed to reject invitation");
  }

  // ---- Generic link ----
  static previewInviteLink(code: string): Promise<InviteLinkPreview> {
    return apiFetchJson<InviteLinkPreview>(`${BASE}/invite-links/${code}`);
  }

  static acceptInviteLink(code: string): Promise<{ campaignId: number }> {
    return apiFetchJson<{ campaignId: number }>(`${BASE}/invite-links/${code}/accept`, {
      method: "POST",
    });
  }
}
